export var getCheckboxStatus = function (filterValues, current) {
    if (!filterValues) {
        return false;
    }
    switch (filterValues.length) {
        case 0:
            return false;
        case 1:
            return filterValues[0] === current ? true : false;
        case 2:
            return true;
        default:
            return false;
    }
};
